module.exports = __webpack_public_path__ + "static/flags/CZ-6bbe4864d06b33b55b8ab6747ab6cbdd.gif";